import * as React from 'react';
import * as _ from 'lodash';
import VirtualList from 'react-tiny-virtual-list';
import { Link } from 'react-router-dom';

import * as DetailFormCommon from './common';
import { NavigationLinks } from '../../common/navigation';
import { Formatters } from '../../common/formatters';

export const RegionalComponentListDetailFormComponentDetailsShortcuts = ({
    appText,
    handleFormInputChange,
    handleSubmitForm,
    handleSaveChanges,
    handleLinkNavigation,
    numFormChanges,
    formData,
    allComponents,
    currentInventoryItem,
    currentInventoryId,
    defaultInputProps,
    defaultBoxHeight,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    const regionalComponentListId = Formatters.getStr(formData, 'regionalComponentListId', '');

    const definedComponents = _.reject(allComponents, (o) => Formatters.getInt(o, 'componentId') === 0 || String(Formatters.getInt(o, 'inventoryId')) === String(currentInventoryId) || String(_.get(o, '_id', '')) === String(currentInventoryId));

    if (_.size(definedComponents) <= 0) { return (<div />); }

    const getItemId = (c: any) => _.get(c, '_id') || _.get(c, 'inventoryId');
    const shortcuts = (_.size(definedComponents)) ?
        _.map(definedComponents, (c, i) => {
            const itemId = getItemId(c);
            const invLink = NavigationLinks.regionalComponentListDetail(regionalComponentListId, String(itemId));
            const componentCustomName = (_.get(c, 'componentName') && _.get(c, 'componentName') !== _.get(c, 'component.name')) ?
                _.get(c, 'componentName') : _.get(c, 'component.name');

            const linkText = `${_.get(c, 'componentId', '0')} - ${componentCustomName}`;

            return (
                <Link
                    onClick={(e) => {
                        handleLinkNavigation(e, itemId, invLink);
                        e.preventDefault();
                    }}
                    key={itemId}
                    title={linkText}
                    to={invLink}
                >
                    {linkText}
                </Link>
            );
        }) : (<div />);

    return (
        <DetailFormCommon.RegionalDetailFormSection title={sectionTitle}>
            <div className="list-shortcuts">
                <VirtualList
                    height={defaultBoxHeight ? defaultBoxHeight : 80}
                    itemCount={_.size(shortcuts)}
                    itemSize={22}
                    className="virtual-list-shortcuts"
                    renderItem={(i) => (
                        <div className="virtual-list-shortcut-container" style={i.style} key={i.index}>{shortcuts[i.index]}</div>
                    )}
                />
            </div>
        </DetailFormCommon.RegionalDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/regional-component-lists/detail-form/component-details-shortcuts.tsx